class MFRFadingTexts {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      entry: ".fading-text__entry",
      stickyWrapper: ".fading-text__image",
      stickyElement: ".fading-text__image-inner",
      image: ".fading-text__image img",
    };

    this.init();
  }

  init() {
    this.$entry = this.$element.find(this.selectors.entry);
    this.$stickyWrapper = this.$element.find(this.selectors.stickyWrapper);
    this.$stickyElement = this.$element.find(this.selectors.stickyElement);
    this.$image = this.$element.find(this.selectors.image);

    // this.initGsap();
    this.initSticky();
  }

  initSticky() {
    const endTrigger =
      this.$stickyWrapper.outerHeight() - this.$stickyElement.outerHeight();

    ScrollTrigger.create({
      trigger: this.$stickyElement,
      start: `top top+=${$("header.header .header__wrapper").height()}`,
      end: `+=${endTrigger}`,
      pin: true, // pin the element
      pinSpacing: false,
    });
  }

  initGsap() {
    if (gsap && gsap.to) {
      gsap.set(this.$entry, {
        opacity: 0,
      });

      this.$entry.each((i, e) => {
        ScrollTrigger.create({
          trigger: $(e),
          start: `top 50%`,
          end: "bottom 50%",
          onEnter: () => {
            gsap.to($(e), { opacity: 1 });
            $(e).addClass("is-active");

            //this.updateImages($(e).data('index'))
            this.animateFading();
          },
          onEnterBack: () => {
            gsap.to($(e), { opacity: 1 });
            $(e).addClass("is-active");

            //this.updateImages($(e).data('index'))
            this.animateFading();
          },
          onLeave: () => {
            // if (i + 1 == this.$entry.length) return;
            // gsap.to($(e), { opacity: 0 });
            $(e).removeClass("is-active");
            this.animateFading();
          },
          onLeaveBack: () => {
            // gsap.to($(e), { opacity: 0 });
            $(e).removeClass("is-active");
            this.animateFading();
          },
        });
      });
    }
  }

  animateFading() {
    const opacitySettings = [1, 0.3, 0.1, 0];
    for (let index = 1; index <= 3; index++) {
      const activeIndex = this.$element
        .find(`${this.selectors.entry}.is-active`)
        .data("index");
      const beforeElement = this.$element.find(
        `${this.selectors.entry}[data-index="${activeIndex - index}"]`
      );
      const afterElement = this.$element.find(
        `${this.selectors.entry}[data-index="${activeIndex + index}"]`
      );

      gsap.to(beforeElement, {
        opacity: opacitySettings[index] ?? 0,
      });
      gsap.to(afterElement, {
        opacity: opacitySettings[index] ?? 0,
      });
    }
  }

  updateImages(index) {
    console.log("UPDATE IMAGES", index);
    const image = this.$element.find(
      `${this.selectors.image}[data-index="${index}"]`
    );
    console.log("IMAGE", image);

    if (!image.length) return;
    this.$image.removeClass("is-active");
    image.addClass("is-active");
  }
}
